module.exports = {"320202001":"崇安寺街道","320202002":"通江街道","320202003":"广瑞路街道","320202004":"上马墩街道","320202005":"江海街道","320202006":"广益街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320202.json
// module id = 936
// module chunks = 0